import * as React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faFileAlt } from "@fortawesome/free-solid-svg-icons"
import { faAngleDoubleRight } from "@fortawesome/free-solid-svg-icons"

const BlogCard = ({ slug }) => {
  const data = useStaticQuery(graphql`
    query BlogCardQuery {
      site {
        siteMetadata {
          siteUrl
        }
      }
      allMicrocmsBlog {
        edges {
          node {
            title
            description
            slug
            thumbnail {
              url
            }
          }
        }
      }
    }
  `)
  const edge = data.allMicrocmsBlog.edges.find(n => {
    return n.node.slug === slug
  })
  const node = edge.node
  const title = node.title
  const description = node.description
  const thumbnail = node.thumbnail.url
  const url = `${data.site.siteMetadata.siteUrl}blog/${node.slug}`

  return (
    <a
      href={url}
      className="border rounded p-3 inline-block shadow-sm
    hover:bg-blue-50 hover:shadow transform hover:-translate-y-1 transition duration-500 ease-in-out blog-card"
    >
      <div className="mb-2">
        <div className="inline-block text-sm rounded text-gray-50 bg-blue-500 px-3 py-1">
          <div className="flex flex-nowrap items-center">
            <FontAwesomeIcon icon={faFileAlt} className="mr-2" />
            関連記事
          </div>
        </div>
      </div>
      <div className="flex flex-nowrap">
        <div>
          <div style={{ width: "160px" }}>
            <img
              className="px-0"
              src={`${thumbnail}?w=160&auto=format`}
              alt="サムネイル"
              width="160"
            />
          </div>
        </div>
        <div className="ml-4">
          <div className="text-gray-800 font-medium mb-2 break-all text-sm md:text-base">
            {title}
          </div>
          <div className="text-gray-500 text-sm hidden md:block">
            {description}
          </div>
          <div className="flex flex-row-reverse">
            <div className="inline-block text-sm rounded-sm text-gray-50 bg-blue-500 px-3 py-1 mt-1">
              記事を読む
              <FontAwesomeIcon icon={faAngleDoubleRight} className="ml-2" />
            </div>
          </div>
        </div>
      </div>
    </a>
  )
}

export default BlogCard
